<template>
  <div>
    <div class="row" ref="brainTreeCreditCard">
      <div class="col">
        <strong>Credit Card</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-control">
          <label for="card-number" class="form-label">Card Number</label>
          <div class="braintree-field" id="card-number" ref="number"></div>
          <span class="validation-errors"
                v-for="error in errors.collect('braintree_credit_card_number')">{{ error }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-sm-6 col">
        <div class="form-control">
          <label for="expiry-date" class="form-label">Expiration Date</label>
          <div class="braintree-field" id="expiry-date" ref="expiryDate"></div>
          <span class="validation-errors"
                v-for="error in errors.collect('braintree_credit_card_expiry_date')">{{ error }}</span>
        </div>
      </div>
      <div class="col-lg-6 col-sm-6 col">
        <div class="form-control">
          <label for="cvv" class="form-label">CVV</label>
          <div class="braintree-field" id="cvv" ref="cvv"></div>
          <span class="validation-errors"
                v-for="error in errors.collect('braintree_credit_card_cvv_code')">{{ error }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentMethodMixin from "@mixins/paymentMethodMixin";
import braintree from 'braintree-web';

export default {
  name: 'brainTreeCreditCard',
  mixins: [paymentMethodMixin],
  data: () => ({
    hostedFieldsInstance: null,
    deviceData: null,
    loading: true,
  }),
  inject: [
    '$validator'
  ],
  computed: {
    token() {
      return this.paymentMethod.public.token || null;
    },
  },
  mounted() {
    this.initForm()
  },
  methods: {
    initForm() {
      braintree.client.create({authorization: this.token})
        .then(clientInstance => this.createFields(clientInstance))
    },
    createFields(clientInstance) {
      braintree.dataCollector.create({
        client: clientInstance,
      }, (err, dataCollectorInstance) => {
        if (err) {
          console.error(err);
          return;
        }
        this.deviceData = dataCollectorInstance.deviceData;
      });

      braintree.hostedFields.create({
          client: clientInstance,
          styles: {
            input: {
              'font-size': '1rem',
              color: '#495057'
            }
          },
          fields: {
            number: {
              selector: this.$refs['number'],
            },
            cvv: {
              selector: this.$refs['cvv'],
            },
            expirationDate: {
              selector: this.$refs['expiryDate'],
            }
          }
        }, (hostedFieldsErr, hostedFieldsInstance) => {
          this.loading = false;
          if (hostedFieldsErr) {
            console.error(hostedFieldsErr.message);
          } else {
            this.hostedFieldsInstance = hostedFieldsInstance;
          }
        }
      )
    },
    async prePaymentRequest() {
      return await new Promise((resolve, reject) => {
        if (!this.hostedFieldsInstance || !this.token) {
          return reject(new Error("Payment gateway failure. Please try again later."));
        }

        if (this.isPaymentTypeAlreadySet) {
          return resolve(true);
        }

        const {deviceData} = this;

        this.hostedFieldsInstance.tokenize().then(payload => {
          this.$store.commit('payment/setPaymentType', this.paymentMethodName);
          this.$store.commit('payment/setPaymentData', Object.assign({}, payload, {deviceData}))

          return resolve(true);
        }).catch(error => {
          this.$store.dispatch('payment/reset');

          if (!this.errors.count()) {
            this.$scrollTo(this.$refs['brainTreeCreditCard']);
          }

          if (error.code === "HOSTED_FIELDS_FIELDS_INVALID") {
            this.errors.add({
              field: 'braintree_credit_card_number',
              msg: "The card number entered is invalid"
            });
          } else if (error.code === "HOSTED_FIELDS_FIELDS_EMPTY") {
            this.errors.add({
              field: 'braintree_credit_card_number',
              msg: "Credit Card is required or incorrect"
            });
            this.errors.add({
              field: 'braintree_credit_card_cvv_code',
              msg: "CVV/CVC Code is required or incorrect"
            });
            this.errors.add({
              field: 'braintree_credit_card_expiry_date',
              msg: "Expiration Date is required or incorrect"
            });
          } else if (error.code === "HOSTED_FIELDS_FAILED_TOKENIZATION") {
            this.errors.add({
              field: 'braintree_credit_card_number',
              msg: "Your credit card was declined."
            });
          }

          return reject(false);
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.bootstrap-basic {
  background: white;
}

.braintree-field {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;

  &.braintree-hosted-fields-valid {
    border-color: green;
    box-shadow: 0 0 0 0.2rem rgb(0, 128, 0, 0.25);
  }
}

.braintree-hosted-fields-focused {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.braintree-hosted-fields-focused.is-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
</style>
